(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sort-select"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sort-select')) {
    class SortSelect extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('.sort-select__toggle');
        this.panel = this.querySelector('.sort-select__panel');
        this.select = this.querySelector('.sort-select__native');
        this.currentLabel = this.querySelector('.sort-select__current');
        this.optionEls = Array.from(this.querySelectorAll('.sort-select__option'));

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
        this.toggle.addEventListener('keydown', this.onToggleKeydown.bind(this));
        this.optionEls.forEach((option) => {
          option.addEventListener('click', this.onOptionClick.bind(this));
          option.addEventListener('keydown', this.onOptionKeydown.bind(this));
        });
        document.addEventListener('click', this.onDocumentClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpen() ? this.close() : this.open();
      }

      onToggleKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.isOpen() ? this.close() : this.open();
        }
      }

      onOptionClick(event) {
        this.selectOption(event.currentTarget);
      }

      onOptionKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectOption(event.currentTarget);
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.toggle.focus();
        }
      }

      selectOption(optionEl) {
        const value = optionEl.dataset.value;
        this.select.value = value;
        this.optionEls.forEach((option) => {
          const selected = option === optionEl;
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        this.currentLabel.textContent = optionEl.textContent.trim();
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
        this.close();
      }

      isOpen() {
        return this.hasAttribute('open');
      }

      open() {
        this.setAttribute('open', '');
        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.removeAttribute('open');
        this.panel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
      }
    }

    customElements.define('sort-select', SortSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
